const API_BASE = import.meta.env.VITE_API_URL || '/api';

export class ApiError extends Error {
  public data: Record<string, unknown>;
  constructor(
    public status: number,
    message: string,
    data?: Record<string, unknown>
  ) {
    super(message);
    this.name = 'ApiError';
    this.data = data || {};
  }
}

export async function api<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  if (!response.ok) {
    if (response.status === 401 && !path.startsWith('/auth/') && window.location.pathname !== '/login') {
      const returnUrl = window.location.pathname + window.location.search;
      if (returnUrl && returnUrl !== '/login') {
        sessionStorage.setItem('returnUrl', returnUrl);
      }
      window.location.href = '/login';
      return new Promise<T>(() => {});
    }
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new ApiError(response.status, body.error || 'Request failed', body);
  }

  if (response.status === 204) return undefined as T;
  return response.json();
}

export function uploadFileToS3(url: string, file: File, onProgress: (pct: number) => void): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('PUT', url, true);
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.upload.onprogress = (e) => {
      if (e.lengthComputable) onProgress(Math.round((e.loaded / e.total) * 100));
    };
    xhr.onload = () => (xhr.status >= 200 && xhr.status < 300 ? resolve() : reject(new Error(`Upload failed: ${xhr.status}`)));
    xhr.onerror = () => reject(new Error('Upload failed'));
    xhr.send(file);
  });
}
